import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Account } from '../../../../../../shared/types/modules/account';

export const useAccountRegisterHistory = (account?: Account) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = account || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [account]);

    return {
        formik,
    };
};
